import type { ReactNode } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { FullModal } from '@/_components';

import { OnboardingContext } from './context';
import type { OnboardingContextType } from './types';

export function OnboardingProvider({ children }: { children: ReactNode }) {
  const [showOnboardingVideo, setShowOnboardingVideo] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');
  const handleShowVideo = useCallback((url: string) => {
    setUrl(url);
    setShowOnboardingVideo(true);
  }, []);

  const handleHideVideo = useCallback(() => {
    setUrl('');
    setShowOnboardingVideo(false);
  }, []);

  const value: OnboardingContextType = useMemo(
    () => ({
      showOnboardingVideo,
      showVideo: handleShowVideo,
      hideVideo: handleHideVideo,
    }),
    [showOnboardingVideo, handleShowVideo, handleHideVideo]
  );

  return (
    <OnboardingContext.Provider value={value}>
      {children}
      <FullModal
        open={showOnboardingVideo}
        onClose={handleHideVideo}
        className="flex flex-col gap-6 md:max-w-5xl"
        disableInternalClosing
      >
        <video controls preload="auto" className="rounded-xl" src={url} />
      </FullModal>
    </OnboardingContext.Provider>
  );
}
